import { Component, Inject, OnInit } from '@angular/core';
import { SipService } from '../services/sip.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EveCall } from '../models/eve-call';

@Component({
  selector: 'app-dtmf-dialog',
  templateUrl: './dtmf-dialog.component.html',
  styleUrls: ['./dtmf-dialog.component.css']
})
export class DtmfDialogComponent {

  digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { call: EveCall },
    public dialogRef: MatDialogRef<DtmfDialogComponent>
  ) {}

 
  async sendDTMF(digit: string) {
    console.log(`🔢 Sending DTMF: ${digit}`);
    // Call sendDTMF on the active EveCall instance
    await this.data.call.sendDTMF(digit);
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
